webpackJsonp([64377754316571],{

/***/ 1098:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"deck","mid_text_1":null,"sirlins_filename":"0010_pillage.jpg","type":"Minor Spell","subtype":null,"cost":1,"ATK":null,"HP":null,"rules_text_1":"Deal 1 damage to a base. Steal ① from that player.","rules_text_2":"If you have a Pirate, instead deal 2 damage and steal ②.","rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"Pillage","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":null,"color":"Red","spec":null,"bottom":"Magic","rulings":[{"ruling":"If the player has less gold than you're trying to steal, steal as much as you can. You can only gain as much gold as you actually take from the other player.","date":"2016-03-19T07:00:00.000Z","author":"Sirlin"}],"keywords":[],"slug":"pillage"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"pillage","keywords":[],"imageRegex":"/pillage.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-pillage-a19d8c392971de572987.js